import React, {Suspense, useMemo, useRef, lazy} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import moment from 'moment';

import ModulePreview from '../../components/ModulePreview';
import drupalSettings from '../../drupalSettings';
import {connect} from 'react-redux';
import filterChange from '../../actions/filterChange';
import {FILTER_DATES} from '../../constants';
import {pushFiltersApply, pushFiltersClose} from 'js/helpers/gtm';
import {convertDatesToString, prepareDates} from '../../helpers';

import styles from './SearchModuleDates.module.scss';

const ModuleDatesForm = lazy(() => import('./components/ModuleDatesForm'));

const cx = classnames.bind(styles);
export const wordings = drupalSettings?.bookingBlock || {};

const SearchModuleDates = function ({
  dataUrl,
  className,
  activeFilter,
  filterChangeAction,
  onChange,
  hotelDirectId,
}) {
  const toglerRef = useRef(null);
  const data = useMemo(function () {
    return prepareDates(dataUrl);
  }, [dataUrl]);

  const previewValues = useMemo(function () {
    const [fromDate, toDate] = data;
    return [{
      label: wordings.dateInPlaceholder,
      value: fromDate ? convertDatesToString(fromDate) : undefined,
      readOnly: true,
      id: 'date-in-field',
      name: 'date-in-field',
    }, {
      label: wordings.dateOutPlaceholder,
      value: toDate ? convertDatesToString(toDate) : undefined,
      readOnly: true,
      id: 'date-out-field',
      name: 'date-out-field',
    }]
  }, [data]);
  const isActive = useMemo(() => activeFilter === FILTER_DATES, [activeFilter]);

  const onFormSubmit = function (data) {
    const [startDate, toDate] = data;
    const startMoment = moment(startDate);
    const toMoment = moment(toDate);
    onChange({
      dateIn: startMoment.format('YYYY-MM-DD'),
      nbNight: toMoment.diff(startMoment, 'days'),
    }, FILTER_DATES)
    // TODO: SEARCH: fix gtm event tracking
    // pushFiltersApply('dates')
    closeModal();
  }

  const onPreviewClick = function (e) {
    if (!isActive) {
      e?.stopPropagation();
      filterChangeAction('activeFilter', FILTER_DATES);
    } else {
      onFormClose();
    }
  };

  const onFormClose = function () {
    pushFiltersClose('dates');
    closeModal();
  };

  const closeModal = () => {
    filterChangeAction('activeFilter', null);
  };

  return (
    <div className={cx('root', className)}>
      <ModulePreview
        icon="CALENDAR"
        ref={toglerRef}
        values={previewValues}
        onClick={onPreviewClick}
      />
      {isActive && (
        <Suspense>
          <ModuleDatesForm
            data={data}
            hotelDirectId={hotelDirectId}
            togler={toglerRef.current}
            onSubmit={onFormSubmit}
            onClose={onFormClose}
          />
        </Suspense>
      )}
    </div>
  )
}

SearchModuleDates.propTypes = {
  dataUrl: PropTypes.shape({
    dateIn: PropTypes.string,
    nbNight: PropTypes.number,
  }),
  className: PropTypes.string,
  activeFilter: PropTypes.string,
  filterChangeAction: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  hotelDirectId: PropTypes.string,
}

export default connect(({searchBox, url}) => ({
  dataUrl: {
    dateIn: url?.uiParams?.dateIn,
    nbNight: url?.uiParams?.nbNight,
  },
  activeFilter: searchBox?.activeFilter,
  hotelDirectId: url?.uiParams?.hotelDirectId || '',
}), {
  filterChangeAction: filterChange,
})(SearchModuleDates);
